// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summary-mobile__item[data-v-6aaf3cc2]{border:1px solid #c8c8d4;border-radius:10px}.summary-mobile__item-menu-activator[data-v-6aaf3cc2]{right:9px;top:2px}", ""]);
// Exports
module.exports = exports;
